<template>
    <div v-loading="loading">
        <div class="brand-menu">
            <div class="g-wrapper brand-menu-text" style="text-align: left;"><a href="/">首页</a> &gt; 我的购物车</div>
        </div>
        <!-- <div class="g-wrapper">
        <div class="shop-rate shop-rate-cart"></div>
        <div class="clearfix"></div>
    </div>-->

        <div class="g-wrapper shopcart-main" id="shopcartContainer">
            <table class="m-shopcart-list">
                <thead>
                    <tr>
                        <th class="select">
                            <input type="checkbox" v-model="selectAll" @change="selectAllF" />
                        </th>
                        <th class="goods">商品信息</th>
                        <th class="price">单价</th>
                        <th class="count">数量</th>
                        <th class="total">金额</th>
                        <th class="total">成本中心</th>
                        <th class="handle">操作</th>
                    </tr>
                </thead>
                <tbody data-gid="1">
                    <tr class="shopcart-goods" v-for="(item, key) in goodList" :key="key">
                        <td>
                            <input type="checkbox" class="select tb-check" @change="checkedChange(key)" checked />
                        </td>
                        <td>
                            <div class="m-goods-item">
                                <a :href="'/procInfo?sku=' + item.SKU" class="pic" target="_blank">
                                    <img
                                        v-lazy="
                                            'http://mallmgr.cesseon.com/api/Shop/GetImageSize?width=240&name=' + item.PicName + '&type=1'
                                        "
                                    />
                                </a>
                                <div class="info">
                                    <p class="title" style="padding-top: 20px;">
                                        <a :href="'/procInfo?sku=' + item.SKU" target="_blank">{{ item.SKUName }}</a>
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <p>
                                <strong class="g-highlight">￥{{ (item.DiscountPrice / 100).toFixed(2) }}/{{ item.SKUUnit }}</strong>
                            </p>
                            <p class="initial">
                                <strong>￥ {{ (item.StandUnitPrice / 100).toFixed(2) }}</strong>
                            </p>
                        </td>
                        <td style="position: relative;">
                            <div class="m-count-handle g-clearfix">
                                <a href="javascript:void 0;" class="btn minus" @click="minus(item)">-</a>
                                <input type="text" class="input" v-model="item.Count" @blur="changePrice(item)" />
                                <a href="javascript:void 0;" class="btn plus" @click="plus(item)">+</a>
                            </div>
                        </td>
                        <td>
                            <strong class="g-highlight">￥{{ (convertPrice(item.DiscountPrice) * item.Count).toFixed(2) }}</strong>
                        </td>
                        <td>
                            <el-select v-model="item.CostCenter" placeholder="请选择成本中心" style="width: 160px;">
                                <el-option
                                    v-for="(cost, Ckey) in CostCenters"
                                    :key="Ckey"
                                    :label="cost.CostCenter"
                                    :value="cost.CostCenter"
                                >
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model="item.CostCenter" placeholder="请输入成本中心" style="width: 140px;"></el-input> -->
                        </td>
                        <td>
                            <a href="javascript:void 0;" @click="delGoods(item)">删除</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="m-shopcart-balance" style="display: flex;">
                <div class="balance-handle" style="flex: 1">
                    <a href="/" class="tobuy">返回继续购物</a>
                    <a href="javascript:void 0;" @click="delSelection">删除选中商品</a>
                </div>
                <div class="remark">
                    <el-input type="textarea" :rows="4" placeholder="请输入订单备注" v-model="Remark"> </el-input>
                </div>
                <div class="balance-money">
                    <p>
                        总金额（不含运费）：
                        <strong class="g-highlight">￥ {{ sumPrice.toFixed(2) }}</strong>
                    </p>
                    <p>
                        <a href="javascript:void 0;" class="btn-submit" @click="submit">结算</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { GlobalFun } from '@/common/utils';
import { OrderApi, ShopCartApi } from '../common/api';
export default {
    name: 'shopcar',
    data() {
        return {
            loading: false,
            selectAll: true,
            goodList: null,
            userinfo: null,
            sumPrice: 0,
            CostCenters: [],
            CostCenterValue: '',
            Remark: ''
        };
    },
    methods: {
        selectAllF() {
            if (this.selectAll) {
                $('.select.tb-check').prop('checked', true);
                for (let item of this.goodList) {
                    this.sumPrice += +item.Count * (item.DiscountPrice / 100).toFixed(2);
                }
            } else {
                this.sumPrice = 0;
                $('.select.tb-check').prop('checked', false);
            }
        },
        submit() {
            this.loading = true;
            let sum = 0;
            for (let item of this.goodList) {
                sum += +item.Count * (item.DiscountPrice / 100).toFixed(2);
            }
            let items = $('.tb-check:checkbox');
            let subData = [];
            for (let i = 0; i < items.length; i++) {
                if ($(items[i]).prop('checked')) {
                    let item = this.goodList[i];
                    for (let j = 0; j < this.goodList.length; j++) {
                        if (this.goodList[j].ID == item.ID) {
                            subData.push(this.goodList[j]);
                        }
                    }
                }
            }
            if (subData.length == 0) {
                this.$message({
                    message: '请添加商品',
                    type: 'info'
                });
                this.loading = false;
                return;
            }
            let data = {
                Remark: this.Remark,
                ShopShoppingCart: subData
            };
            OrderApi.submitOrder(data).then(res => {
                this.$router.push('/OrderList');
            });
        },

        //减商品数量
        minus(item) {
            if (item.Count <= 1) {
                this.$message({
                    message: '采购数不能小于1',
                    type: 'info'
                });
                return;
            }
            this.loading = true;
            ShopCartApi.UpdateShoppingCartNum(item.ID, item.Count)
                .then(res => {
                    --item.Count;
                    this.sumPrice -= this.convertPrice(item.DiscountPrice);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        convertPrice(price) {
            return (price / 100).toFixed(2);
        },
        //加商品数量
        plus(item) {
            this.loading = true;
            ShopCartApi.UpdateShoppingCartNum(item.ID, item.Count)
                .then(res => {
                    ++item.Count;
                    //添加+号防止字符串拼接
                    this.sumPrice += +this.convertPrice(item.DiscountPrice);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        //单个删除
        delGoods(item) {
            this.$confirm('是否删除该商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(async () => {
                    ShopCartApi.ShoppingCartRemove([item.ID]).then(res => {
                        this.goodList = this.goodList.filter(d => d.ID !== item.ID);
                        this.sumPrice -= (item.Count * (item.DiscountPrice / 100)).toFixed(2);
                    });
                })
                .catch(() => {});
        },
        //多选删除
        delSelection() {
            this.$confirm('是否删除选中商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            })
                .then(async () => {
                    let items = $('.tb-check:checkbox');
                    let sum = 0;
                    let ids = [];
                    for (let i = 0; i < items.length; i++) {
                        if ($(items[i]).prop('checked')) {
                            let item = this.goodList[i];
                            ids.push(item.ID);
                            sum += +((item.DiscountPrice / 100) * item.Count).toFixed(2);
                            $(items[i]).prop('checked', false);
                            this.goodList = this.goodList.filter(d => d.ID !== item.ID);
                        }
                    }
                    //删除
                    ShopCartApi.ShoppingCartRemove(ids).then(res => {
                        this.sumPrice -= sum;
                    });
                })
                .catch(() => {});
        },
        //文本框数量更新（失去焦点）
        changePrice(item) {
            this.loading = true;
            ShopCartApi.UpdateShoppingCartNum(item.ID, item.Count)
                .then(res => {
                    this.sumPrice = 0;
                    for (let i of this.goodList) {
                        this.sumPrice += +(i.Count * this.convertPrice(i.DiscountPrice)).toFixed(2);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        //单个选
        checkedChange(key) {
            let checks = $('.select.tb-check');
            let item = this.goodList[key];
            if ($(checks[key]).prop('checked')) {
                this.sumPrice += +((item.DiscountPrice / 100).toFixed(2) * item.Count).toFixed(2);
            } else {
                this.sumPrice -= ((item.DiscountPrice / 100).toFixed(2) * item.Count).toFixed(2);
            }
            for (let i = 0; i < checks.length; i++) {
                if ($(checks[i]).prop('checked')) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                    break;
                }
            }
        }
    },
    async mounted() {
        this.loading = true;
        GlobalFun.getCookie('UserInfo').then(res => {
            if (!res) {
                this.$router.push('/login');
            }
        });
        this.goodList = Object.assign([], new Array());
        ShopCartApi.MyShopShoppingCart()
            .then(async res => {
                this.goodList = [...res];
                for (let item of this.goodList) {
                    this.sumPrice += +item.Count * (item.DiscountPrice / 100).toFixed(2);
                    this.CostCenters = await ShopCartApi.GetCostCenterListInProtal();
                }
            })
            .finally(() => {
                this.loading = false;
            });

        this.loading = false;
    }
};
</script>

<style>
.remark {
    margin-right: 10px;
}
@import url('../assets/css/shopcart.css');
</style>
